import { React, useState, useRef } from "react";
// import "./PartnershipFirm.css";
import "./PrivateLimitedCompany.css";
import ContactPopup from "./ContactPopup";

const PartnershipFirm = () => {
  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);
  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>Partnership Firm Registration</h1>

        <p className="subtitle">
          Simple, Fast & Affordable Registration for Your Business
        </p>

        <p className="desc">
          We help you register your Partnership Firm with complete legal support and documentation. Whether you’re starting a small business or teaming up with partners, we make the process smooth and hassle-free.
        </p>

        <div className="badges">
          <span>✔ Quick & Easy Process</span>
          <span>✔ Expert Legal Support</span>
          <span>✔ Affordable Pricing</span>
          <span>✔ 100% Online Assistance</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact}>
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS PARTNERSHIP FIRM */}
      <div className="section">
        <h2>What is a Partnership Firm?</h2>
        <p>
          A Partnership Firm is a business structure where two or more individuals come together to run a business and share profits and losses as per an agreed ratio. It is governed by the Indian Partnership Act, 1932.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of Partnership Firm</h2>
        <ul>
          <li>Easy to start with minimal compliance</li>
          <li>Low registration cost</li>
          <li>Shared responsibilities and resources</li>
          <li>Flexible decision-making</li>
          <li>Less regulatory burden compared to companies</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our Services Include</h2>
        <ul>
          <li>Drafting of Partnership Deed</li>
          <li>Stamp Duty & Notarization</li>
          <li>PAN Application for Firm</li>
          <li>Registration with Registrar of Firms (Optional but recommended)</li>
          <li>Bank Account Assistance</li>
          <li>GST Registration (if required)</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>

        <h3>For Partners:</h3>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar / Passport / Voter ID</li>
          <li>Passport-size Photograph</li>
          <li>Address Proof (Bank Statement / Utility Bill)</li>
        </ul>

        <h3>For Business Address:</h3>
        <ul>
          <li>Rent Agreement (if rented)</li>
          <li>NOC from Owner</li>
          <li>Utility Bill (Electricity/Water)</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>Registration Process</h2>
        <ul>
          <li>Consultation – Discuss business details and partner roles</li>
          <li>Drafting Deed – Prepare partnership agreement</li>
          <li>Execution – Sign and notarize the deed</li>
          <li>PAN Application – Apply for firm PAN</li>
          <li>Registration (Optional) – File with Registrar of Firms</li>
        </ul>
      </div>

      {/* PRICING */}
      <div className="section">
        <h2>Pricing Plans</h2>

        <div className="grid">

          <div className="card blue">
            <h3>Basic Plan</h3>
            <ul>
              <li>Partnership Deed Drafting</li>
              <li>Notarization Support</li>
            </ul>
          </div>

          <div className="card purple">
            <h3>Standard Plan</h3>
            <ul>
              <li>Everything in Basic</li>
              <li>PAN Application</li>
              <li>Bank Account Assistance</li>
            </ul>
          </div>

          <div className="card orange">
            <h3>Premium Plan</h3>
            <ul>
              <li>Everything in Standard</li>
              <li>GST Registration</li>
              <li>Firm Registration with Registrar</li>
            </ul>
          </div>

        </div>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Experienced Professionals</li>
          <li>Fast Processing</li>
          <li>Transparent Pricing</li>
          <li>Dedicated Support</li>
          <li>End-to-End Service</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Is registration mandatory?</b> No, but recommended for legal benefits.</p>
        <p><b>Minimum partners required?</b> Minimum 2 partners required.</p>
        <p><b>Bank account without registration?</b> Yes, with deed and PAN.</p>
        <p><b>Difference between registered & unregistered firm?</b> Registered firms get legal protection and can file suits.</p>
      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Start Your Partnership Firm Today</h2>
        <p>Get expert assistance and register your business smoothly.</p>

        <div className="cta-buttons" >
          <button
            onClick={() => setOpenPopup(true)}
          >Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"}
          >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default PartnershipFirm;